export const matchmakingRequestRoutes = [
  {
    path: '/matchmaking-requests',
    name: 'MatchmakingRequests',
    component: () =>
      import(
        /* webpackChunkName: "matchmakingRequests" */ '@/views/Dashboard/MatchmakingRequests/MatchmakingRequests.vue'
      ),
  },
  {
    path: '/matchmaking-requests/:id',
    name: 'MatchmakingRequestDetail',
    component: () =>
      import(
        /* webpackChunkName: "matchmakingRequestsDetail" */ '@/views/Dashboard/MatchmakingRequests/MatchmakingRequestDetail.vue'
      ),
  },
  {
    path: '/matchmaking-requests/internal/:id',
    name: 'MatchmakingInternalRequestDetail',
    component: () =>
      import(
        /* webpackChunkName: "matchmakingInternalRequestsDetail" */ '@/views/Dashboard/MatchmakingRequests/MatchmakingInternalRequestDetail.vue'
      ),
  },
];
